import clsx from 'clsx'
import React from 'react'

import Input, { Props as InputProps } from './Input'

type Props = Omit<InputProps, 'type' | 'onChange' | 'value'> & {
  value: number | undefined
  onChange: (value: number | null | undefined) => void
}

const Currency = function () {
  return (
    <span
      className={clsx('flex flex-row items-center justify-center size-full')}
    >
      €
    </span>
  )
}

export default function PriceInput({ value, onChange, ...props }: Props) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target
    const cursorPosition = input.selectionStart || 0

    let newValue = input.value.replace(/[^0-9.]/g, '')

    if (!newValue) {
      onChange(null)
      return
    }

    // Handle decimal places
    const decimalIndex = newValue.indexOf('.')
    if (decimalIndex !== -1) {
      const wholeNumber = newValue.slice(0, decimalIndex)
      const decimals = newValue.slice(decimalIndex + 1)
      newValue = wholeNumber + '.' + decimals.slice(0, 2)
    }

    const number = parseFloat(newValue)
    if (!isNaN(number)) {
      onChange(Math.round(number * 100))
      requestAnimationFrame(() => {
        input.setSelectionRange(cursorPosition, cursorPosition)
      })
    }
  }

  return (
    <Input
      {...props}
      Icon={Currency}
      type="text"
      value={value == null ? '' : (value / 100).toFixed(2)}
      onChange={handleChange}
    />
  )
}
